// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"playerSelect__gradient-bg5__bNVSY","pbr":"playerSelect__pbr__FexIU"};